import { gql } from '@apollo/client';
import { BILLING_FIELDS } from '../../fragments';

export const GET_BILLING_BY_REFERENCE_ID = gql`
  ${BILLING_FIELDS}
  query billing($referenceId: ID!){
    billingByReferenceId(referenceId: $referenceId)
    {
      ...BillingFields
    }
  }
`;
